<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div class="d-flex flex-column flex">
					<div id="navbar" class="navbar navbar-expand-lg flex-nowrap box-shadow">
						<div class="navbar-text nav-title flex" id="pageTitle">Teams</div>

						<!-- Create new -->
						<div class="py-0">
							<a href="#/teams/new" class="btn btn-sm hover-darken theme-accent btn-block">
								<i class="far fa-fw fa-plus"></i>
								<span class="hidden-folded d-inline">New Team</span>
							</a>
						</div>

						<!-- Search field -->
						<div class="collapse navbar-collapse no-grow order-lg-1" id="navbarToggler">
							<form class="input-group m-2 my-lg-0">
								<span class="input-group-btn">
									<button type="button" class="btn no-border no-bg no-shadow">
										<i class="fa fa-search"></i>
									</button>
								</span>
								<input
									type="text"
									v-model="filter"
									class="form-control"
									placeholder="Search teams..."
								/>
							</form>
						</div>
					</div>

					<!-- Page Content -->
					<div class="content-main">
						<div class>
							<!-- Page content goes here -->
							<b-table
								ref="table"
								id="teamtable"
								responsive="lg"
								striped
								hover
								:show-empty="true"
								:items="provider"
								:fields="fields"
								:current-page="currentPage"
								:per-page="perPage"
								:filter="filter"
								:sort-by.sync="sortBy"
								:sort-desc.sync="sortDesc"
							>
								<!-- Active -->
								<!-- <template slot="active" slot-scope="data">
									<div class="mx-auto w40">
										<label class="ui-switch ui-switch-md theme-accent">
											<input @change="setActive(data.item)" type="checkbox" v-model="data.item.active" />
											<i></i>
										</label>
									</div>
								</template>-->

								<!-- Users -->
								<template slot="users" slot-scope="data">
									<span
										v-if="data.item.users && data.item.users.length > 0"
										v-tippy="{ theme: 'popover' }"
										:title="listNames(data.item.users, 'Members')"
									>
										<i class="fas fa-users faw"></i>
										{{ (data.item.users && data.item.users.length) || 0 }}
									</span>
									<span v-if="!(data.item.users && data.item.users.length > 0)" class="text-danger">
										<i class="fas fa-exclamation-circle" />
										None
									</span>
								</template>

								<!-- Actions -->
								<template slot="actions" slot-scope="data">
									<div class="mx-auto w60">
										<a
											:href="`#/teams/${data.item.id}`"
											class="btn btn-sm btn-icon btn-rounded theme-accent text-white m-0"
											v-tippy
											title="Edit"
										>
											<i class="far fa-edit"></i>
										</a>
										<button
											v-if="!data.item.inProgress"
											@click="deleting = data.item"
											class="btn btn-sm btn-icon btn-rounded hover-darken red text-white m-0"
											v-tippy
											:title="$t('tooltip.delete.item')"
										>
											<i class="far fa-trash"></i>
										</button>
										<button
											v-if="data.item.inProgress"
											class="btn btn-sm btn-icon btn-rounded m-0"
											v-tippy
											title="Removing..."
										>
											<loading type="icon" />
										</button>
									</div>
								</template>

								<template slot="empty">
									<loading type="table" v-if="loading" />
									<div v-if="!loading">There are no records to show</div>
								</template>
							</b-table>
						</div>
					</div>

					<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
						<a class="flex mx-3"
							>Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
								totalRows
							}})</a
						>
						<div>
							<b-pagination
								size="md"
								class="m-1"
								:total-rows="totalRows"
								v-model="currentPage"
								:per-page="perPage"
							></b-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="deleteConfirm" :visible="deleting != false" v-if="deleting">
			<template slot="modal-title">Delete Team</template>
			<div class="row p-4">
				Are you sure you want to delete&nbsp;
				<strong class="text-theme">{{ deleting.name }}</strong
				>?
			</div>
			<template slot="modal-footer">
				<button class="btn primary btn-flat" @click="deleting = false">Cancel</button>
				<button class="btn danger btn-flat" @click="removeTeam(deleting)">Delete</button>
			</template>
		</b-modal>

		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.w40 {
	width: 40px;
}
.w60 {
	width: 62px;
}
</style>

<script>
//UI Components

//Libraries
import _ from "lodash";

//Services
import AuthService from "@/services/AuthService";
import TeamService from "@/services/TeamService";
import store from "@/services/Store";
import notie from "@/services/NotieService";

export default {
	name: "TeamSetup",

	props: ["user"],

	data() {
		return {
			fields: [
				{ key: "name", sortable: true },
				{ key: "desc", label: "Description", sortable: true },
				{ key: "users", label: "Members" },
				{
					key: "actions",
					label: this.$i18n.t("label.actions"),
					thStyle: { "text-align": "center" },
					tdClass: "p-custom p-0 v-mid"
				}
			],
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			filter: "",
			sortBy: null,
			sortDesc: false,
			showInactive: true,
			loading: true,

			deleting: false
		};
	},

	components: {},

	created() {
		//When resizing the window, change the number of rows in the BTable
		//based on the window height, but not too often
		// this.resizeFunc = _.debounce(() => {
		// 	ViewportService.resizeBTable("navbar", "pages", 46, 45, this);
		// }, 250);
		// window.addEventListener("resize", this.resizeFunc);

		// this.perPage = ViewportService.estimateBTable(120, 104, 46, 45);

		this.sortBy = store.get(this, "teams.sortBy");
		this.sortDesc = store.getDefault(this, "teams.sortDesc", false);
		this.showInactive = store.getDefault(this, "teams.showInactive", true);
	},

	destroyed() {
		window.removeEventListener("resize", this.resizeFunc);
	},

	watch: {
		sortBy() {
			store.set(this, "teams.sortBy", this.sortBy);
		},
		sortDesc() {
			store.set(this, "teams.sortDesc", this.sortDesc);
		},
		showInactive() {
			store.set(this, "teams.showInactive", this.showInactive);
			this.refreshTable();
		}
	},

	methods: {
		provider(ctx) {
			ctx.active = !this.showInactive;
			ctx.users = "y";
			return TeamService.listTeams(ctx)
				.then(resp => {
					this.totalRows = resp.data.totalRows;
					return resp.data.teams;
				})
				.catch(err => {
					console.log(err);
					notie.error("Failed to load teams", err);
					return [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		setActive(team) {
			var activeState = (team.active && "active") || "inactive";
			TeamService.saveTeam(team)
				.then(resp => {
					notie.info(`Team "${team.name}" set to ${activeState}`);
				})
				.catch(err => {
					notie.error("Failed to save team", err);
				});
		},

		removeTeam(team) {
			team.inProgress = true;
			if (team.users) {
				notie.error("Cannot delete a team that has members");
				team.inProgress = false;
				this.deleting = false;
				return;
			} else {
				TeamService.removeTeam(team.id)
					.then(resp => {
						notie.info("Team deleted");
						this.refreshTable();
					})
					.catch(err => {
						notie.error("Failed to delete team", err);
					})
					.finally(() => {
						team.inProgress = false;
						this.deleting = false;
						this.$forceUpdate();
					});
			}
		},

		refreshTable() {
			this.$refs.table.refresh();
		},

		listNames(objects, title) {
			if (objects && objects.length > 0) {
				let nameList = `${title}:<br /><br /><ul class='pl-4 pr-3'>`;
				_.each(objects, object => {
					nameList += `<li style="text-align: left;">${object.full_name}</li>`;
				});

				return nameList + "</ul>";
			} else {
				return "";
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/UserMgmt/TeamSetup.vue